import { createApp } from 'vue'
import 'virtual:uno.css'
import App from './App.vue'
import router from '@/router'
import pinia from '@/stores'
import directives from '@/common/js/directives.js' // 注入全局指令
import '@/websocket/index'

import '@/common/scss/index.scss'

const app = createApp(App)

app.use(router).use(pinia).use(directives).mount('#app')
